import { useContext, useState } from 'react';
import { createContext } from 'react';

import { ProductDescriptionProps } from '../@types/ProductDescriptionProps';

export const ProductDescriptionContext = createContext<ProductDescriptionProps>({} as ProductDescriptionProps);

ProductDescriptionContext.displayName = 'ProductDescription';

const ProductDescriptionProvider = (props: ProductDescriptionProps) => {
	const [isOpen, setIsOpen] = useState(false);
	console.log(props);
	return (
		<ProductDescriptionContext.Provider value={{ ...props, isOpen, setIsOpen }}>
			{props.children}
		</ProductDescriptionContext.Provider>
	);
};

export const useProductDescription = () => {
	const context = useContext(ProductDescriptionContext);

	return context;
};

export default ProductDescriptionProvider;
